import { SailBoatIcon } from './SailBoatIcon';

/**
 * author: Google
 * id F1921E38-A25D-41F6-94B6-B6D01C3E0593
 * name sail-boat
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sail-boat.svg
 * tags
 * - Sport 
 * - Transportation + Water 
 */
export const SailingIcon = SailBoatIcon;
export default SailingIcon